import { render, staticRenderFns } from "./companypagestree.vue?vue&type=template&id=c4a9b466&scoped=true&"
import script from "./companypagestree.vue?vue&type=script&lang=js&"
export * from "./companypagestree.vue?vue&type=script&lang=js&"
import style0 from "./companypagestree.vue?vue&type=style&index=0&id=c4a9b466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a9b466",
  null
  
)

export default component.exports